import { useEffect, useState } from 'react'
import { fetchPermissions } from './api'
import type { SettingsPermissions } from './types'
import { isFresh, readCache, writeCache } from '../../shared/cache/localCache'

const KEY = 'settings-permissions'

/** Settings permissions for the signed-in user, cached 5 minutes (also used by the sidebar). */
export function useSettingsAccess(enabled = true) {
  const cached = readCache<SettingsPermissions>(KEY)
  const [perms, setPerms] = useState<SettingsPermissions | null>(cached?.data ?? null)

  useEffect(() => {
    if (!enabled) return
    if (cached && isFresh(cached.timestamp, 5 * 60_000)) return
    fetchPermissions()
      .then((p) => {
        setPerms(p)
        writeCache(KEY, p)
      })
      .catch(() => setPerms(null))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled])

  return perms
}
